import { render } from "./OfficeIcons.vue?vue&type=template&id=6bf900ea&scoped=true"
import script from "./OfficeIcons.vue?vue&type=script&lang=js"
export * from "./OfficeIcons.vue?vue&type=script&lang=js"

import "./OfficeIcons.vue?vue&type=style&index=0&id=6bf900ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf900ea"]])

export default __exports__